import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#EFEFEF",
      d: "M14.481 2.703v4.228h-1.386V2.729c0-.86-.456-1.343-1.352-1.343H2.746c-.895 0-1.36.482-1.36 1.343v13.01c0 .86.465 1.334 1.36 1.334h8.997c.896 0 1.352-.474 1.352-1.335v-4.21h1.386v4.236c0 1.8-.886 2.695-2.669 2.695H2.67C.895 18.459 0 17.564 0 15.764V2.704C0 .912.895 0 2.669 0h9.143c1.783 0 2.67.913 2.67 2.703"
    }, null, -1)
  ])))
}
export default { render: render }